import $ from 'jquery';
import eSputnik from './eSputnik';
import PhoneInputInit from './phone-input';
import { GASubscribe } from './ga/subscribe';
import { allowedLocales } from 'scripts/utils/constants';

const AJAX = '';
let flag = false;

const forms = () => {
  function maskedInputt(event, element) {
    const that = element ? $(element) : $(this);
    const { keyCode } = event;
    if (!that) {
      return;
    }
    const pos = that.get(0).selectionStart;

    const matrix = that.parents(".form-label").length
      ? "+380 __ ___ __ __"
      : " __ ___ __ __";

    if (
      matrix.length === 17 &&
      pos < 4 &&
      keyCode !== 39 && // arrow right
      keyCode !== 37 && // arrow left
      pos < 4 &&
      event.type === "paste"
    ) {
      event.preventDefault();
    }

    let i = 0;
    const def = matrix.replace(/\D/g, "");
    const val = that.val().replace(/\D/g, "");
    let newValue = matrix.replace(/[_\d]/g, (a) => {
      if (
        ((i === 0 && val.length === 1) || pos < 5) &&
        !that.hasClass("js_callback") &&
        ($(".js_landing_form").length === 0 || flag)
      ) {
        return a;
      }
      return i < val.length ? val.charAt(i++) || def.charAt(i) : a;
    });
    flag = true;

    i = newValue.indexOf("_");

    if (i !== -1) {
      if (i < 5) i = 3;
      newValue = newValue.slice(0, i);
    }

    let reg = matrix
      .substr(0, that.val().length)
      .replace(/_+/g, (a) => `\\d{1,${a.length}}`)
      .replace(/[+()]/g, "\\$&");
    reg = new RegExp(`^${reg}$`);

    if (
      !reg.test(that.val()) ||
      that.val().length < 5 ||
      (keyCode > 47 && keyCode < 58)
    ) {
      that.val(newValue.replaceAll("_", ""));
    }

    const isCheckoutPage = window.location.pathname.indexOf("checkout") > -1;
    if (isCheckoutPage) {
      that.addClass("masked");
    }

    if (
      event.handleObj &&
      event.handleObj.origType === "blur" &&
      !(that.val().length >= matrix.length) &&
      !isCheckoutPage
    ) {
      that.val("").removeAttr("value");
    } else if (event.handleObj && event.handleObj.origType === "focus") {
      that.attr("autocomplete", "off");
    }
  }

  const telInputSelector = 'input[type="tel"]:not([id*="bingc"]):not([id="modal-login-code"])';
  $(document).on("focus input new-tel-input-rendered", telInputSelector, PhoneInputInit);

  window.maskedInput = PhoneInputInit.bind(
    null,
    new Event("custom", { cancelable: true }),
    telInputSelector
  );

  const inputPlaceholder = () => {
    const getValue = (element) =>{
      const valueLength = element.val().length;
      if(valueLength){
        element.attr('value', valueLength);
      }else{
        element.removeAttr('value');
      }
    }
    $(document).on('change keyup','.form-label__input:not([type="tel"]):not([type="date"]), .bonus-card__input', function placeholder(){
      const $this = $(this);
      getValue($this);
    }).on('change','.form-label__input[type="tel"]', function placeholder(){
      const $this = $(this);
      getValue($this);
    });
  }


  const textAreaAdaptiveHeight = () =>{
    $(document).on('input', '.form-label textarea', function setTextareaHeight () {
      this.style.height = '0px';
      this.style.height = `${this.scrollHeight}px`;
    });

    // Set height to 0 when form is reset
    $(document).on('reset', function resetTextareaHeight(){
      const textareas = $(this).find('textarea');
      textareas.each(function(){
        this.style.height = '0px';
      });
    });
  }

  const subscribeForm = () =>{
    const button = $('.subscribe-block .wb-btn');
    const subscribeInput = $('.subscribe-block .subscribe-label__input');

    button.on('click', function validation(e){
      e.preventDefault();

      const $this = $(this);
      const input = $this.siblings('input');
      const email = input.val();
      const parents = $this.parents('.subscribe-label');
      const location = window.location.href;
      let locale = $('html').attr('lang');
      if (!(locale in allowedLocales)) {
        locale = allowedLocales.uk;
      }

      $.ajax({
        url: `${AJAX}/api/subscribe`,
        type: 'post',
        data: `email=${email}&page=${location}&locale=${locale}`,
        headers: {
          'Accept-Language': locale
        },
        dataType: 'json',
        success: (success) => {
          const successText =  success.memessage;

          parents.removeClass('error').addClass('success');
          parents.find('.success-text').text(successText);

          eSputnik.CustomerData({ user_email: email, user_phone: "" });
          GASubscribe(email);

          if (window.fbq) {
            window.fbq('track', 'Subscribe');
          }
        },
        error:(error)=>{
          const errorText = error.responseJSON.errors.email[0];

          parents.removeClass('success').addClass('error');
          parents.find('.error-text').text(errorText);
        }
      });
    })

    subscribeInput.on('keyup', function removeErrors (){
      const $this = $(this);
      const parent = $this.parents('.subscribe-label');

      parent.removeClass('error success');
    });
  }

  subscribeForm();
  textAreaAdaptiveHeight();
  inputPlaceholder();
}

export default forms;